const themesEn = {
  "themes.title": "Themes",
  "themes.upload": "Upload zip file",
  "themes.add": "Add theme",
  "themes.add_title": "Theme library",
  "themes.add_short": "Add",
  "themes.added": "{name} was added to your theme library",
  "themes.uploaded": "{name} was uploaded",
  "themes.check_failed": "The theme has errors and wasn't saved:",
  "themes.current": "Current theme",
  "themes.update_available": "Update available: {version}",
  "themes.version": "Version {version}",
  "themes.saved": "Last saved {when}",
  "themes.customize": "Customize",
  "themes.preview": "Preview",
  "themes.rename": "Rename",
  "themes.duplicate": "Duplicate",
  "themes.duplicated": "Theme duplicated",
  "themes.download": "Download theme file",
  "themes.edit_code": "Edit code",
  "themes.delete": "Delete theme",
  "themes.delete_title": "Delete {name}?",
  "themes.delete_body": "This theme and its customizations will be removed. This can't be undone.",
  "themes.deleted": "Theme deleted",
  "themes.none_live": "No theme is live yet. Add one from the theme library.",
  "themes.library": "Theme library",
  "themes.library_hint": "Themes you can customize and publish when you're ready. Only one theme is live at a time.",
  "themes.library_empty": "Add a theme or duplicate your current one to try changes without affecting your store.",
  "themes.publish": "Publish",
  "themes.publish_title": "Publish {name}?",
  "themes.publish_body": "It replaces your current theme on your storefront right away.",
  "themes.published": "{name} is now live",
  "themes.renamed": "Theme renamed",
  "themes.name": "Theme name",
  "themes.source.library": "From the theme library",
  "themes.source.upload": "Uploaded",
  "themes.source.duplicate": "Copy",
  "themes.view_code": "View code",
  "themes.dev_title": "Building your own theme?",
  "themes.dev_body": "Themes use Liquid templates, JSON templates, sections and blocks. Download Sahil as a starting point and upload your .zip.",
  "themes.errors_title": "Theme errors ({n})",
  "themes.errors_clear": "Clear",
  "themes.errors_hint": "Your live store hit these Liquid errors in the last 7 days. Shoppers see the rest of the page; the broken part is left out.",
} as const;

export default themesEn;
